import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "buku_stok_token";
const IS_EMERGENT_PREVIEW =
  typeof window !== "undefined" &&
  window.location &&
  window.location.hostname.toLowerCase().includes("emergent");

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token from localStorage on every request (production only).
api.interceptors.request.use((config) => {
  if (IS_EMERGENT_PREVIEW) return config;
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-redirect to /login on 401 (skip the login call itself). No redirect in
// Emergent preview — there's no login flow there.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (IS_EMERGENT_PREVIEW) return Promise.reject(err);
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.endsWith("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem("buku_stok_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
